module.exports = __webpack_public_path__ + "static/everyday-zen-49fdd33f55d2cd39c8de9d94db97eb66.jpg";